import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BG_COLORS, BORDER_COLORS } from '../../utils/colors';

export interface ExcludeStaffSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/**
 * Тумблер «Скрыть сотрудников» в строке фильтров экранов статистики (магазин, рулетка, промокоды).
 * Значение уходит в `excludeStaff`: бэк убирает ADMIN/OWNER из сумм и списков.
 *
 * Оформлен плашкой в рамке, как соседняя кнопка «Сбросить» (GlassButton secondary): голый тумблер
 * с подписью выпадал из ряда рамочных полей. Кликабельна вся плашка.
 */
export const ExcludeStaffSwitch: React.FC<ExcludeStaffSwitchProps> = ({ checked, onChange }) => {
  const { t } = useTranslation();

  return (
    <FormControlLabel
      control={
        <Switch
          size="small"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          // Зелёный «включено», как у тумблера активности в AdminShopPage: серый тумблер темы не отличить от выключенного
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': { color: '#22c55e' },
            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#22c55e' },
          }}
        />
      }
      label={t('admin:common.hideStaff')}
      sx={{
        m: 0,
        // В ряду десктопа высоту даёт stretch, а в мобильной шторке (колонка) плашка сжималась до 26px
        minHeight: 40,
        pl: 0.5,
        pr: 1.5,
        gap: 0.25,
        borderRadius: '8px',
        background: BG_COLORS.GLASS_DARK,
        border: `1px solid ${BORDER_COLORS.STRONG}`,
        color: '#fff',
        transition: 'border-color 0.3s ease, background 0.3s ease',
        '&:hover': { background: BG_COLORS.GLASS_LIGHT, borderColor: BORDER_COLORS.FOCUS },
        '& .MuiFormControlLabel-label': { fontSize: '0.875rem', lineHeight: 1.5, whiteSpace: 'nowrap' },
      }}
    />
  );
};

export default ExcludeStaffSwitch;
